/**
 * Prefer optional external "more" link; otherwise use WordPress single-post permalink.
 *
 * @param {Record<string, unknown>} e Map venue entry from actMapData
 * @returns {string}
 */
export function resolveDetailUrl(e) {
    if (!e) {
        return '';
    }
    const link = e.link;
    if (link && link !== '' && link !== 'null') {
        return link;
    }
    const permalink = e.permalink;
    return permalink && permalink !== '' ? permalink : '';
}
